var map = {
	"./adjuggernaut/logo_light.png": 73938,
	"./adrev/logo_light.png": 16063,
	"./altus/logo_light.png": 43634,
	"./cartagent/logo_light.png": 49282,
	"./citiesms/logo_light.png": 91156,
	"./defero/logo_light.png": 66034,
	"./hawkemedia/logo_light.png": 81115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21892;